import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";
import { GET_USER_INFO } from "../../utils/constants";
import { makeAuthenticatedGet } from "../../utils/fetchUtils";
import { Spinner } from "react-bootstrap";

function Fellowship() {
  const mainRef = useRef<HTMLHeadingElement>(null);
  const location = useLocation();
  const navigate = useNavigate();

  // User details state
  const [userDetails, setUserDetails] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [isApplied, setIsApplied] = useState(false);

  useEffect(() => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/login");
    }
    document.title = "Fellowship Program - Nclude Portal";
  }, [navigate]);

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  // Fetch user info on mount
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const resp = await makeAuthenticatedGet(GET_USER_INFO);
        if (resp.success && resp.user) {
          setUserDetails(resp.user);
          if (resp.user.fellowshipApplied) {
            setIsApplied(true);
          }
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserDetails();
  }, []);

  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="Fellowship" />
        <main className="doc-container voice-agent-page" tabIndex={-1} id="main-content">
          <section className="landing-page" aria-labelledby="fellowship-heading">
            <h1 className="display-title" id="fellowship-heading" ref={mainRef} tabIndex={-1}>
              Fellowship Program
            </h1>
            <div 
              className="content-container dashboard-container" 
              style={{ 
                height: "auto", 
                minHeight: "unset", 
                padding: isMobile ? "1.5rem 1rem" : "2.5rem 2rem",
                justifyContent: "center",
                marginTop: "1.5rem"
              }}
            >
              <h2 style={{ fontWeight: "600", textAlign: "center" }}>
                I-Stem Fellowship Program
              </h2>
              
              <p className="display-7" style={{ width: isMobile ? "90%" : "65%", margin: "1rem auto", textAlign: "center", lineHeight: "1.6" }}>
                Thank you for your overwhelming response and interest in the I-Stem Fellowship Program. The application deadline has now passed, and applications for this cohort are closed.
              </p>

              <p style={{ fontWeight: "600", fontSize: isMobile ? "1.15rem" : "1.3rem", marginTop: "0.5rem", marginBottom: "1.5rem", color: "#FFD700", textAlign: "center" }}> 
                We will be announcing the selected fellows after 27th September.
              </p> 

              {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                  <Spinner animation="border" role="status" variant="light" style={{ width: "3rem", height: "3rem" }}>
                    <span className="visually-hidden">Loading details...</span>
                  </Spinner>
                </div>
              ) : isApplied ? (
                <div style={{ width: "100%", maxWidth: "600px", margin: "1rem auto 0 auto" }}>
                  <div 
                    role="status" 
                    aria-live="polite" 
                    className="w-full flex flex-col items-center justify-center p-6 md:p-8 bg-white/5 rounded-2xl border border-white/10 backdrop-blur-md text-center shadow-2xl transition duration-300 animate-fade-in"
                  >
                    <div className="w-16 h-16 bg-emerald-500/20 text-emerald-400 rounded-full flex items-center justify-center mb-4 border border-emerald-500/30">
                      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <h3 style={{ fontWeight: "600", fontSize: isMobile ? "1.6rem" : "1.5rem", textAlign: "center" }}>
                      Application Received!
                    </h3>
                    <p className="text-white/95 mb-6 max-w-xl" style={{ fontSize: isMobile ? "1.4rem" : "1.05rem", textAlign: "center" }}>
                      Thank you for completing the screening interview. We have successfully received your application and our team is currently evaluating all submissions.
                    </p>
                    <div className="text-white/95 text-sm space-y-4 md:space-y-2 mb-6 text-left w-full bg-black/35 p-5 rounded-xl border border-white/5">
                      {userDetails?.userName && <p><strong className="text-white/60">Name:</strong> {userDetails.userName}</p>}
                      {userDetails?.email && <p className="break-all"><strong className="text-white/60">Email:</strong> {userDetails.email}</p>}
                      {userDetails?.phoneNumber && <p><strong className="text-white/60">Mobile:</strong> {userDetails.phoneNumber}</p>}
                    </div>
                    <p className="text-white/80 mb-6 max-w-lg" style={{ fontSize: isMobile ? "1.3rem" : "0.9rem" }}>
                      Our team will contact you regarding the results and next steps after 27th September.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 mt-2 justify-center items-center w-full">
                      <button
                        onClick={() => navigate('/')}
                        style={{ fontSize: isMobile ? "1.4rem" : "0.9rem" }}
                        className="w-full sm:w-auto sm:py-3 py-2.5 px-6 rounded-lg bg-cyan-500 hover:bg-cyan-600 active:bg-cyan-700 text-white font-semibold transition duration-200 shadow-lg shadow-cyan-500/20"
                      >
                        Go to Home
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{ width: "100%", maxWidth: "600px", margin: "1rem auto 0 auto" }}>
                  <div 
                    role="status" 
                    aria-live="polite" 
                    className="w-full flex flex-col items-center justify-center p-6 md:p-8 bg-white/5 rounded-2xl border border-white/10 backdrop-blur-md text-center shadow-2xl transition duration-300 animate-fade-in"
                  >
                    <div className="w-16 h-16 bg-cyan-500/20 text-cyan-400 rounded-full flex items-center justify-center mb-4 border border-cyan-500/30">
                      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <h3 style={{ fontWeight: "600", fontSize: isMobile ? "1.6rem" : "1.5rem", textAlign: "center" }}>
                      Applications Closed
                    </h3>
                    <p className="text-white/90 mb-4 max-w-lg" style={{ fontSize: isMobile ? "1.4rem" : "1rem", textAlign: "center" }}>
                      The screening and application process for this cohort ended on 6th September 2026.
                    </p>
                    <p className="text-white/70 mb-6 max-w-md" style={{ fontSize: isMobile ? "1.3rem" : "0.85rem", textAlign: "center" }}>
                      We will be announcing the selected fellows after 27th September. Stay tuned for future cohorts and announcements!
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 mt-2 justify-center items-center w-full">
                      <button
                        onClick={() => navigate('/')}
                        style={{ fontSize: isMobile ? "1.4rem" : "0.9rem" }}
                        className="w-full sm:w-auto sm:py-3 py-2.5 px-6 rounded-lg bg-cyan-500 hover:bg-cyan-600 active:bg-cyan-700 text-white font-semibold transition duration-200 shadow-lg shadow-cyan-500/20"
                      >
                        Go to Home
                      </button>
                      <button
                        onClick={() => navigate('/jobs')}
                        style={{ fontSize: isMobile ? "1.4rem" : "0.9rem" }}
                        className="w-full sm:w-auto sm:py-3 py-2.5 px-6 rounded-lg border border-white/20 hover:bg-white/10 text-white/90 font-medium transition duration-200"
                      >
                        Explore Opportunities
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}

export default Fellowship;

